import { equals, isEmpty, isNil, map, reject, type } from "ramda";
import { useCallback } from "react";
var isNothing = function (x) { return isNil(x) || isEmpty(x); };
var isObjectOrArray = function (v) {
    var vType = type(v);
    return vType === "Object" || vType === "Array";
};
var removeEmpty = function (x) {
    return reject(isNothing, map(function (t) { return (isObjectOrArray(t) ? removeEmpty(t) : t); }, x));
};
var sanitizeObject = function (x) { return (type(x) === "Object" ? removeEmpty(x) : x); };
export var deepEqual = function (arg1, arg2) { return equals(sanitizeObject(arg1), sanitizeObject(arg2)); };
export var useNotEqual = function (arg1) { return useCallback(function (arg2) { return !deepEqual(arg1, arg2); }, [arg1]); };
//# sourceMappingURL=use-not-equals.js.map